import React, { ReactNode } from 'react'
import { IconButton, IconButtonProps, Tooltip } from '@mui/material'

interface IconPopupButtonProps extends IconButtonProps {
  children: ReactNode
  tooltipText: string
  onClick: () => void
}

export const IconPopupButton = ({
  children,
  tooltipText,
  onClick,
  ...props
}: IconPopupButtonProps) => {
  return (
    <Tooltip title={tooltipText}>
      <IconButton onClick={onClick} color='primary' {...props}>
        {children}
      </IconButton>
    </Tooltip>
  )
}
